import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const Analytics = ({ color, size = IconScale.M }: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M6.38398 1.63107V3.01148C4.47829 3.78288 3.13398 5.6512 3.13398 7.8335C3.13398 10.7054 5.4621 13.0335 8.33398 13.0335C10.5163 13.0335 12.3846 11.6892 13.156 9.7835H14.5364C13.7081 12.4206 11.2444 14.3335 8.33398 14.3335C4.74413 14.3335 1.83398 11.4233 1.83398 7.8335C1.83398 4.92303 3.74686 2.45934 6.38398 1.63107ZM8.33398 1.3335C11.9238 1.3335 14.834 4.24364 14.834 7.8335C14.834 8.05287 14.8231 8.26971 14.8019 8.4835H7.68398V1.36559C7.89777 1.34436 8.11461 1.3335 8.33398 1.3335ZM8.98398 2.67372V7.1835H13.4937C13.2005 4.83133 11.3361 2.96704 8.98398 2.67372Z"
        fill={color}
      />
    </svg>
  );
};

export default Analytics;
